// styled components
import { Row, Col, Table, Empty, Radio, Form, Input, Popover  } from "antd";
// models
import { PostulacionModel } from "../../../../../models/PostulacionesModel/postulacion.model";
// icons
import { EyeOutlined, DownloadOutlined, WarningOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { ModalVisualizarDocumentos } from "../../../../../components/Generales/ModalVisualizarDocumentos";
import { useGestionarPostulaciones } from "../../../../../hooks/useGestionarPostulaciones";
import { TemplateContext } from "../../../../../utils/template_context";
import { DownloadFile } from "../../../../../utils/DownloadFile";
import apiParticipantes from "../../../../../api/Participantes/api-participantes";
import getStorageUser from "../../../../../middlewares/GetStorageUser"
import { fontFamily } from "html2canvas/dist/types/css/property-descriptors/font-family";

// models
interface IProps {
  postulacion: any;
  setAllPostulaciones: any;
  allpostulaciones: any;
  descargarArchivo: any;
  isBeps?: boolean;
  lineasConvocatoria: any;
  setCountSubsanable: any;
  countSubsanable: any;
  setIdPostulacion?: any;
  idPostulacion?: any;
  setObservaciones?: any;
  observaciones?: any;
}

export const InformacionPostulacion: React.FC<IProps> = (props: IProps) => {

  const { lineasconvocatoria, obtenerLineasConvocatorias } =
    useGestionarPostulaciones();
  // state
  const [disablesubsanar, setDisableSubsanar] = useState<boolean>(false);
  const [modaldocumento, setModalDocumento] = useState<boolean>(false);
  const [documento, setDocumento] = useState<string>("");
  const context = useContext(TemplateContext);
  const [user, setUser] = useState<any>({});

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  const validateObservaciones = async () => {
    const postulacion = await apiParticipantes.consultarPostulacion(props?.postulacion?.id_postulacion);
    props.setCountSubsanable(
      props.postulacion.estado === 'Subsanar' ? 1 : 0
    )
    props.setObservaciones(postulacion?.data?.observaciones || '')
  }

  useEffect(() => {
    getUser();
    validateObservaciones()
  }, [props.postulacion])

  // disabled subsanar
  useEffect(() => {
    obtenerLineasConvocatorias();
    return setDisableSubsanar(false);
  }, []);
  // columns table documentación técnica
  const columnasDocumentaciontecnicaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 100,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) => (
        <Row className="width-100">
          <Col span={24}>{datos.tipo_documento || datos.descripcion}</Col>
        </Row>
      ),
    },
    {
      title: "Nombre del documento",
      width: 100,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{datos.url_participante}</span>
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 50,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{fontSize: 'small'}}>
                      <p className="font-color-00904C">Fecha aceptado: <span style={{fontWeight: 'bold'}}>{datos.fecha_aceptado}</span></p>
                      <p className="font-color-00904C">Aceptado por: <span style={{fontWeight: 'bold'}}>{datos.aceptado_por}</span></p>
                      <hr />
                      <p className="font-color-DB2828">Fecha rechazado: <span style={{fontWeight: 'bold'}}>{datos.fecha_rechazado}</span></p>
                      <p className="font-color-DB2828">Rechazado por: <span style={{fontWeight: 'bold'}}>{datos.rechazado_por}</span></p>
                    </div>
                  }>
                  <InfoCircleOutlined/>
                </Popover>
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Aceptado
          </Col>
        </Row>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        if (user.documento != '43188189') {
          if (datos.url_documento || datos.url_participante) {
            return (
              <>
                <Row className="width-100">
                  <Col span={24} className="justify-content-center">
                    <Radio.Group
                      value={datos.checkaceptartecnico}
                      onChange={(e: any) =>
                        handlechangechecktecnicos(
                          e,
                          datos,
                          index,
                          props.postulacion
                        )
                      }
                    >
                      <Radio value={true}>Sí</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
              </>
            );
          }
        }
      },
    },
    {
      title: (
        <>
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Acciones
            </Col>
          </Row>
          <Row className="width-100">
            <Col span={12} className="justify-content-center">
              <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                Ver
              </span>
            </Col>
            <Col span={12} className="justify-content-center">
              <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                Descargar
              </span>
            </Col>
          </Row>
        </>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        if (datos.url_documento || datos.url_participante) {
          return (
            <>
              <Row className="width-100">
                <Col span={12} className="justify-content-center">
                  <EyeOutlined
                    onClick={() => {
                      setModalDocumento(true);
                      setDocumento(datos.url_participante);
                    }}
                  />
                </Col>
                <Col span={12} className="justify-content-center">
                  <DownloadOutlined
                    onClick={() =>
                      DownloadFile(datos.url_participante)
                    }
                  />
                </Col>
              </Row>
            </>
          );
        }
      },
    },
  ];
  //  columns table documentación técnica
  const columnasDocumentacionadministrativaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 380,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <Row className="width-100">
          <Col span={24}>{datos.descripcion}</Col>
        </Row>
      ),
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{fontSize: 'small'}}>
                      <p className="font-color-6435C9">Fecha subsanado: <span style={{fontWeight: 'bold'}}>{datos.fecha_subsanado}</span></p>
                      <p className="font-color-6435C9">Subsanado por: <span style={{fontWeight: 'bold'}}>{datos.subsanado_por}</span></p>
                      { datos.url_anterior && (
                        <p className="font-color-6435C9">Ver anterior: {' '}
                          <span style={{fontWeight: 'bold'}}>
                            <EyeOutlined
                            onClick={() => {
                            setModalDocumento(true);
                            setDocumento(datos.url_anterior);
                            }}/>
                          </span>
                        </p>)
                      }
                      <hr />
                      <p className="font-color-F28C02">Fecha subsanar: <span style={{fontWeight: 'bold'}}>{datos.fecha_subsanar}</span></p>
                      <p className="font-color-F28C02">Actualizado por: <span style={{fontWeight: 'bold'}}>{datos.actualizado_por}</span></p>
                      <hr />
                      <p className="font-color-00904C">Fecha aceptado: <span style={{fontWeight: 'bold'}}>{datos.fecha_aceptado}</span></p>
                      <p className="font-color-00904C">Aceptado por: <span style={{fontWeight: 'bold'}}>{datos.aceptado_por}</span></p>
                      <hr />
                      <p className="font-color-DB2828">Fecha rechazado: <span style={{fontWeight: 'bold'}}>{datos.fecha_rechazado}</span></p>
                      <p className="font-color-DB2828">Rechazado por: <span style={{fontWeight: 'bold'}}>{datos.rechazado_por}</span></p>
                    </div>
                  }>
                  <InfoCircleOutlined/>
                </Popover>
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Subsanar
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checksubsanable"
                  value={datos.checksubsanable}
                  checked={datos.checksubsanable}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, props.postulacion)
                  }
                />
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Aceptado
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checkaceptar"
                  checked={datos.checkaceptar}
                  value={datos.checkaceptar}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, props.postulacion)
                  }
                />
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Rechazado
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checkrechazado"
                  checked={datos.checkcancelar}
                  value={datos.checkcancelar}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, props.postulacion)
                  }
                />
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: (
        <>
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Acciones
            </Col>
          </Row>
          <Row className="width-100">
            <Col span={12} className="justify-content-center">
              Ver
            </Col>
            <Col span={12} className="justify-content-center">
              Descargar
            </Col>
          </Row>
        </>
      ),
      width: 120,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <Row className="width-100">
              <Col span={12} className="justify-content-center">
                {
                  datos && datos.url_participante !== null && datos.url_participante !== "" &&
                  <EyeOutlined
                    onClick={() => {
                      setModalDocumento(true);
                      setDocumento(datos.url_participante);
                    }}
                  />
                }
                {
                  !(datos && datos.url_participante !== null && datos.url_participante !== "") &&
                  <WarningOutlined />
                }
              </Col>
              <Col span={12} className="justify-content-center">
                {
                  datos && datos.url_participante !== null && datos.url_participante !== "" &&

                  <DownloadOutlined
                    onClick={() => DownloadFile(datos.url_participante)}
                  />
                }
                {
                  !(datos && datos.url_participante !== null && datos.url_participante !== "") &&
                  <WarningOutlined />
                }
              </Col>
            </Row>
          </>
        );
      },
    },
  ];
  //   columns table enlaces
  const columnaslinksModal = [
    {
      title: "URL",
      width: 260,
      render: (datos: any, record: any, index: number) => {
        //console.log(datos, "url");
        return (
          <Row className="width-100">
            <Col span={24}>
              <a href={datos.url} target="_blank">{datos.url}</a>
            </Col>
          </Row>
        );
      },
    },
  ];

  const obtenerFecha = () => {
    let fechaActual = new Date();
    let anio = fechaActual.getFullYear();
    let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
    let dia = ('0' + fechaActual.getDate()).slice(-2);
    let hora = ('0' + fechaActual.getHours()).slice(-2);
    let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
    let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;
    return fechaYHora
  }
  //   handle
  const handlechangecheck = (
    e: any,
    datos: any,
    index: number,
    postulacion: PostulacionModel
  ) => {
    let todosJSON = JSON.parse(JSON.stringify(props.allpostulaciones));
    for (var i in todosJSON) {
      if (todosJSON[i].id_postulacion === postulacion.id_postulacion) {
        if (e.target.name === "checksubsanable") {
          props.postulacion.documentos_administrativos[index].checksubsanable =
            true;
          props.postulacion.documentos_administrativos[index].checkaceptar =
            false;
          props.postulacion.documentos_administrativos[index].checkcancelar =
            false;
          props.postulacion.documentos_administrativos[index].actualizado_por = `${user.nombres} ${user.apellidos}`
          props.postulacion.documentos_administrativos[index].fecha_subsanar = obtenerFecha()
          todosJSON[i].documentos_administrativos[index].checksubsanable = true;
          todosJSON[i].documentos_administrativos[index].checkaceptar = false;
          todosJSON[i].documentos_administrativos[index].checkcancelar = false;
          todosJSON[i].documentos_administrativos[index].actualizado_por = `${user.nombres} ${user.apellidos}`
          todosJSON[i].documentos_administrativos[index].fecha_subsanar = obtenerFecha()
          props.setCountSubsanable(1);
        }
        if (e.target.name === "checkaceptar") {
          if (props.postulacion.documentos_administrativos[index].checksubsanable) {
            props.setCountSubsanable(0);
          }
          props.postulacion.documentos_administrativos[index].checksubsanable =
            false;
          props.postulacion.documentos_administrativos[index].checkaceptar =
            true;
          props.postulacion.documentos_administrativos[index].checkcancelar =
            false;
          props.postulacion.documentos_administrativos[index].aceptado_por = `${user.nombres} ${user.apellidos}`
          props.postulacion.documentos_administrativos[index].fecha_aceptado = obtenerFecha()
          todosJSON[i].documentos_administrativos[index].checksubsanable =
            false;
          todosJSON[i].documentos_administrativos[index].checkaceptar = true;
          todosJSON[i].documentos_administrativos[index].checkcancelar = false;
          todosJSON[i].documentos_administrativos[index].aceptado_por = `${user.nombres} ${user.apellidos}`
          todosJSON[i].documentos_administrativos[index].fecha_aceptado = obtenerFecha()
        }
        if (e.target.name === "checkrechazado") {
          if (props.postulacion.documentos_administrativos[index].checksubsanable) {
            props.setCountSubsanable(0);
          }
          props.postulacion.documentos_administrativos[index].checksubsanable =
            false;
          props.postulacion.documentos_administrativos[index].checkaceptar =
            false;
          props.postulacion.documentos_administrativos[index].checkcancelar =
            true;
          props.postulacion.documentos_administrativos[index].rechazado_por = `${user.nombres} ${user.apellidos}`
          props.postulacion.documentos_administrativos[index].fecha_rechazado = obtenerFecha()
          todosJSON[i].documentos_administrativos[index].checksubsanable =
            false;
          todosJSON[i].documentos_administrativos[index].checkaceptar = false;
          todosJSON[i].documentos_administrativos[index].checkcancelar = true;
          todosJSON[i].documentos_administrativos[index].rechazado_por = `${user.nombres} ${user.apellidos}`
          todosJSON[i].documentos_administrativos[index].fecha_rechazado = obtenerFecha()
        }
      }
    }
    return props.setAllPostulaciones(todosJSON);
  };
  const handlechangechecktecnicos = (
    e: any,
    datos: any,
    index: number,
    postulacion: PostulacionModel
  ) => {
    let todosJSON = JSON.parse(JSON.stringify(props.allpostulaciones));
    for (var i in todosJSON) {
      if (e.target.value == true) {
        props.postulacion.documentos_tecnicos[index].checkaceptartecnico =
        e.target.value;
        props.postulacion.documentos_tecnicos[index].aceptado_por = `${user.nombres} ${user.apellidos}`
        props.postulacion.documentos_tecnicos[index].fecha_aceptado = obtenerFecha()
      }
      if (e.target.value == false) {
        props.postulacion.documentos_tecnicos[index].checkaceptartecnico =
        e.target.value;
        props.postulacion.documentos_tecnicos[index].rechazado_por = `${user.nombres} ${user.apellidos}`
        props.postulacion.documentos_tecnicos[index].fecha_rechazado = obtenerFecha()
      }
      if (todosJSON[i].id_postulacion === postulacion.id_postulacion) {
        props.postulacion.documentos_tecnicos[index].checkaceptartecnico =
          e.target.value;
        todosJSON[i].documentos_tecnicos[index].checkaceptartecnico =
          e.target.value;
      }
    }
    return props.setAllPostulaciones(todosJSON);
  };
  return (
    <>
      <Row
        className="width-100"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <Col
          span={6}
          className="font-size-12px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          {props.isBeps ? "Nombre Participante" : "Nombre representante"}
        </Col>
        {props.isBeps && (
          <Col
            className="font-size-12px font-family-Montserrat-Regular"
            span={18}
          >
            {props.postulacion.nombre_participante}
          </Col>
        )}
        {
          <Col
            className="font-size-12px font-family-Montserrat-Regular"
            span={18}
          >
            {props.postulacion.nombre_representante}
          </Col>
        }

        {props.isBeps ? null : (
          <>
            <Col
              span={6}
              className="font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Tipo de participante
            </Col>
            <Col
              className="font-size-12px font-family-Montserrat-Regular"
              span={18}
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.tipo_participante === "1"
                ? "Persona Natural"
                : props.postulacion.tipo_participante === "2"
                  ? "Persona Juridica"
                  : props.postulacion.tipo_participante === "3"
                    ? "Grupo Conformado"
                    : null}
            </Col>
            <Col
              span={6}
              className="font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Línea
            </Col>
            <Col
              className="font-size-12px font-family-Montserrat-Regular"
              span={18}
            >
              {/* {props.postulacion.linea_convocatoria && props.postulacion.linea_convocatoria !== null
                ? props.lineasConvocatoria.filter(
                    (x: any) => x.idlineaconvocatoria === props.postulacion.linea_convocatoria
                  )[0].nombre
                : null} */}
              {props.postulacion.linea_convocatoria}
            </Col>
            <Col
              span={6}
              className="font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Categorías
            </Col>
            <Col
              className="font-size-12px font-family-Montserrat-Regular"
              span={18}
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.categoria_linea_convocatoria}
            </Col>
          </>
        )}
        {props.postulacion.documentos_tecnicos !== null &&
          props.postulacion.documentos_tecnicos.length > 0 ? (
          <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Documentos Técnicos
            </label>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentaciontecnicaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_tecnicos}
            />
          </Col>
        ) : null}
        {props.postulacion.documentos_administrativos !== null &&
          props.postulacion.documentos_administrativos.length > 0 &&
          user.documento != '43188189' ? (
          <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Documentos administrativos
            </label>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionadministrativaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_administrativos}
            />
          </Col>
        ) : null}
        {
          user.documento != '43188189' ?
            <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
            >
              <Form
                name="basic"
                layout="vertical"
                initialValues={{ remember: true }}
                autoComplete="off"
              >
                <Input.TextArea value={props?.observaciones} rows={15} maxLength={2000} required onChange={(e) => props.setObservaciones(e.target.value)} placeholder="Ingresa las observaciones" />
              </Form>
            </Col>
          :
          <span></span>
        }
        {props.postulacion.links !== null ? (
          <Col
            span={24}
            className="font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Enlaces del proyecto
            </label>
            <Table
              pagination={false}
              style={{ paddingTop: "16px" }}
              columns={columnaslinksModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.links}
            />
          </Col>
        ) : null}
      </Row>
      <ModalVisualizarDocumentos
        visualizar={modaldocumento}
        setVisualizar={setModalDocumento}
        state={{ documento: documento }}
        tipo="participante"
      />
    </>
  );
};
